// body-builder.ts
var BodyBuilder = class _BodyBuilder {
  queryTypedArguments;
  query_name;
  fields;
  variables;
  constructor(queryTypedArguments) {
    this.queryTypedArguments = queryTypedArguments;
  }
  withQueryName(queryName) {
    return Object.assign(this, { query_name: queryName });
  }
  withFields(fields) {
    return Object.assign(this, { fields });
  }
  withVariables(variables) {
    if (variables == null) return this;
    return Object.assign(this, { variables });
  }
  build() {
    const queryFields = _BodyBuilder.graphFieldsQuery(this.fields);
    const varNames = [];
    const varDeclarations = [];
    for (const variable of Object.entries(this.variables || {})) {
      const key = variable[0];
      const type = this.queryTypedArguments[this.query_name][key];
      varNames.push(`$${key}: ${type}`);
      varDeclarations.push(`${key}: $${key}`);
    }
    const varNamesString = varNames.length !== 0 ? `(${varNames.join(", ")})` : "";
    const varDeclarationsString = varDeclarations.length !== 0 ? `(${varDeclarations.join(", ")})` : "";
    const query = `query q${varNamesString} { ${this.query_name}${varDeclarationsString} ${queryFields} }`;
    return this.variables ? { query, variables: this.variables } : { query };
  }
  /* Prepare the fields for the graphql request.
  * From [ 'a', 'b.c', 'd.e', 'd.g' ] we need to get { a b { c } d { e g } }
  */
  static graphFieldsQuery(params) {
    const m = {};
    for (const param of params) {
      const parts = param.split(".");
      let branch = m;
      parts.forEach((value, index) => {
        if (index === parts.length - 1) branch[value] = "";
        else {
          if (branch[value] == null) branch[value] = {};
          branch = branch[value];
        }
      });
    }
    return JSON.stringify(m).replace(/"/g, "").replace(/,/g, "").replace(/:/g, " ");
  }
};
export {
  BodyBuilder
};
//# sourceMappingURL=body-builder.mjs.map
